function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface17810302"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25 43 C 15.058594 43 7 34.941406 7 25 C 7 15.058594 15.058594 7 25 7 C 34.941406 7 43 15.058594 43 25 C 43 34.941406 34.941406 43 25 43 Z M 25 43 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25 6.601562 C 14.855469 6.601562 6.601562 14.855469 6.601562 25 C 6.601562 35.144531 14.855469 43.398438 25 43.398438 C 35.144531 43.398438 43.398438 35.144531 43.398438 25 C 43.398438 14.855469 35.144531 6.601562 25 6.601562 Z M 19.398438 33 L 16.199219 33 L 16.199219 21 L 19.398438 21 Z M 17.800781 18.601562 C 16.914062 18.601562 16.199219 17.882812 16.199219 17 C 16.199219 16.117188 16.914062 15.398438 17.800781 15.398438 C 18.683594 15.398438 19.398438 16.117188 19.398438 17 C 19.398438 17.882812 18.683594 18.601562 17.800781 18.601562 Z M 34.601562 33 L 31.398438 33 L 31.398438 27 C 31.398438 25.460938 30.140625 24.199219 28.601562 24.199219 C 27.058594 24.199219 25.800781 25.460938 25.800781 27 L 25.800781 33 L 22.601562 33 L 22.601562 21 L 25.800781 21 L 25.800781 22.453125 C 26.734375 21.554688 28 21 29.398438 21 C 32.273438 21 34.601562 23.328125 34.601562 26.199219 Z M 34.601562 33 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.72bd909776a020c65fc58167372f0724.svg";
export { ForwardRef as ReactComponent };